export default "__VITE_ASSET__DGR4VQE9__"